module.exports = __webpack_public_path__ + "img/image24.d5536cc4.jpg";